import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Button, Spinner, Alert } from "react-bootstrap";
import * as familiaApi from "../../api/familia";
import * as perfilApi from "../../api/perfil";
import { useAuth } from "../../auth/AuthContext";

/** Página que abre el invitado desde el enlace del correo para aceptar o rechazar la invitación
 * directa de un Jefe de familia. */
export default function ResolverInvitacion() {
  const { actualizarSesion } = useAuth();
  const { token } = useParams();
  const [detalle, setDetalle] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [resuelto, setResuelto] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    familiaApi.obtenerInvitacion(token)
      .then(setDetalle)
      .catch((err) => setError(err?.response?.data?.mensaje || "No se pudo cargar la invitación."))
      .finally(() => setCargando(false));
  }, [token]);

  const resolver = async (aceptar) => {
    setGuardando(true);
    setError("");
    try {
      await familiaApi.resolverInvitacion(token, aceptar);
      if (aceptar) {
        actualizarSesion(await perfilApi.refrescarToken());
      }
      setResuelto(aceptar ? "aceptada" : "rechazada");
    } catch (err) {
      setError(err?.response?.data?.mensaje || "No se pudo resolver la invitación.");
    } finally {
      setGuardando(false);
    }
  };

  if (cargando) return <Spinner animation="border" />;

  return (
    <div>
      <h4 className="mb-3">Invitación a una familia</h4>
      <div className="fs-card" style={{ maxWidth: 520 }}>
        {error && <Alert variant="danger" className="py-2">{error}</Alert>}
        {resuelto ? (
          <Alert variant={resuelto === "aceptada" ? "success" : "secondary"} className="mb-0">
            {resuelto === "aceptada" ? "¡Listo, ya sos parte de la familia!" : "Invitación rechazada."}
          </Alert>
        ) : detalle && (
          <>
            <p>
              <strong>{detalle.nombreJefe}</strong> te invitó a unirte a <strong>{detalle.nombreFamilia}</strong>.
            </p>
            {detalle.estado !== "Pendiente" ? (
              <Alert variant="secondary" className="mb-0">Esta invitación ya fue resuelta ({detalle.estado}).</Alert>
            ) : (
              <div className="d-flex gap-2">
                <Button variant="outline-danger" disabled={guardando} onClick={() => resolver(false)}>Rechazar</Button>
                <Button variant="primary" disabled={guardando} onClick={() => resolver(true)}>
                  {guardando ? <Spinner size="sm" animation="border" /> : "Aceptar"}
                </Button>
              </div>
            )}
          </>
        )}
        <div className="mt-3">
          <Link to="/mi-familia" className="small">Ir a Mi Familia</Link>
        </div>
      </div>
    </div>
  );
}
